export const aufgabenStyles = {
    fieldsContentAufgabe: {
        box: {
            gridTemplateColumns: ['1fr', '1fr 1fr 1fr 1fr'],
            gap: 2,
        },
        promptField: {
            gridColumn: '1 / -1',
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        },
        prompt2langField: {
            gridColumn: 'span 2',
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        },
        prompt2langFieldFirst: {
            gridColumn: '1 / 3',
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        }
    },
    pageCreateAufgabe: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        }
    },
    pageUpdateAufgabe: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        dialogActions: {
            position: 'sticky',
            bottom: 0,
            zIndex: 2,
            mx: -2,
            mb: -2,
            px: 2,
            py: 2,
            backgroundColor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
        }
    },
    filterTableAufgaben: {
        box: {
            backgroundColor: 'white'
        }
    },
    tableAufgaben: {
        box: {
            minHeight: 600,
            height: "100%",
            overflow: 'auto',
            width: "100%"
        },
        paper: {
            padding: 2,
            paddingBottom: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    }
}